export enum EnterNewPasswordType {
  changePassword = 'changePassword',
  createPassword = 'createPassword',
  recoveryPassword = 'recoveryPassword',
}
